module.exports = __webpack_public_path__ + "static/media/saveMoney.be73b483.png";